import { useState } from "react";

/**
 * Custom hook for managing list modal state
 * @returns {Object} Object containing modal state and handlers
 */
export const useListModal = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    items: [],
  });

  const openModal = (items) => {
    setModalState({
      isOpen: true,
      items: Array.isArray(items) ? items : [],
    });
  };

  const closeModal = () => {
    setModalState({
      isOpen: false,
      items: [],
    });
  };

  return {
    isOpen: modalState.isOpen,
    items: modalState.items,
    openModal,
    closeModal,
  };
};

